let API_BASE = 'https://api.sellingpower.com';

if (process.env.NODE_ENV === 'production') {
  API_BASE = 'https://api.sellingpower.com';
} else if (process.env.NODE_ENV === 'staging') {
  API_BASE = '//api-staging.sellingpower.com';
} else {
  //API_BASE = '//localhost:5000';
  API_BASE = 'https://api.sellingpower.com';
}

export const NODE_API_BASE = API_BASE;



// WEBPACK FOOTER //
// ./src/config/node-api.js